import { useQuery } from '@ts-core/lib/apollo';

import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';
import { ProfessorActivity } from '../types/index';

import { getActivityQuery, GetActivityQueryResult, GetActivityQueryVariables } from '../graphql/queries/getActivityQuery';

export interface ActivityHookInput {
  courseId: string;
  activityId: string;
}

export interface ActivityHookPayload {
  activity?: ProfessorActivity;
  loading: boolean;
}

export default function useActivity({ courseId, activityId }: ActivityHookInput): ActivityHookPayload {
  const { showErrorNotification } = useSnackbarNotifications();

  const { data, loading } = useQuery<GetActivityQueryResult, GetActivityQueryVariables>(getActivityQuery, {
    variables: { courseId, activityId },
    onError: showErrorNotification,
  });

  return {
    activity: data?.activity,
    loading,
  };
}
